<template>
    <div class="d-flex flex-column bg-white">
        <HeaderBar/>
        <div class="reportTitle mt-5 ml-1">Estado Sanitario</div>
        <b-card header-border-variant="Primary" class="shadow  px-0" no-body>
            <b-row no-gutters>

                <b-card-body>
                    <span style="font-weight: 600;font-size: 18px;">
                        <div class="d-flex justify-content-between">
                            <b-form-datepicker id="fecha_ini" name="fecha_ini" v-model="init_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>

                            <b-form-datepicker id="fecha_fin" name="fecha_fin" v-model="end_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>
                           
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>Indicador Sanitario</div>
                            <div>Resultado</div>
                        </div>
                    </span>

                    <blockquote class="blockquote mb-0"></blockquote>

                    <b-card-text class="mt-3 mb-3">
                        <div class="d-flex justify-content-between">
                            <div> Animales Enfermos:</div>
                            <div> {{sick_animals_qty}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Diarrea en terneros:</div>
                            <div> {{diarreaChilds}} %</div>
                        </div>
                        <!-- <div class="d-flex justify-content-between">
                            <div> Sangrados positivos brucelosis:</div>
                            <div> {{brucelosis}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Sangrados positivos tuberculosis:</div>
                            <div> {{tuberculosis}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Rabia:</div>
                            <div> {{rabia}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Incidencia Diarreas:</div>
                            <div> {{diarrea}} </div>
                        </div> -->
                        <div class="d-flex justify-content-between">
                            <div> Mortalidad por enfermedades:</div>
                            <div> {{deaths}} %</div>
                        </div>
<!-- 
                        <div class="d-flex justify-content-between">
                            <div> Mortalidad de terneros:</div>
                            <div> {{childs_deaths}}</div>
                        </div> -->
                        <div class="d-flex justify-content-between">
                            <div> Animales con renquera:</div>
                            <div> {{renquera}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Animales con mastitis:</div>
                            <div> {{mastitis}}</div>
                        </div>
                    <div class="d-flex justify-content-between mt-2 px-1">
                        <b-button class="bg-primary w-100 mr-1" @click="modalShow=true">Animales Enfermos</b-button>
                    </div>
                    <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
                        <p class="text-center"><strong>Animales Enfermos</strong></p>
                       <vue-good-table :columns="columns" :rows="sick_animals" styleClass="vgt-table bordered"
                        :search-options="{
                            enabled: false,
                        }" 
                        
                        :pagination-options="{
                            enabled: false,
                        }"
                        
                        :sort-options="{
                            enabled: true,
                        }"
                        >
                        <template slot="table-row" slot-scope="props">

                            <!-- Column: Name -->
                            <span v-if="props.column.field === 'sex'" class="text-center">
                            <span v-if="props.row.sex===false" class="text-center">M</span>
                            <span v-if="props.row.sex===true" class="text-center">H</span>
                            
                            </span>

                            <!-- Column: Status -->
                            <span v-else-if="props.column.field === 'status'">
                            <b-badge :variant="statusVariant(props.row.status)">
                                {{ props.row.status }}
                            </b-badge>
                            </span>

                            <!-- Column: Common -->
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                    
                        </vue-good-table> 
                    </b-modal>
                    </b-card-text>
                </b-card-body>

            </b-row>
        </b-card>
        <ControlMenu />
    </div>
</template>


<script>
import { BCard, BRow, BCardBody, BCardText, BButton, BFormRadio,BFormDatepicker } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue';
import HeaderBar from '@/components/HeaderBar.vue'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'
export default {
    components: {
        BCard,
        BButton,
        BCardBody,
        BCardText,
        BRow,
        ControlMenu,
        HeaderBar,
        VueGoodTable,
        BFormRadio,
        BFormDatepicker
    },
    directives: {
    Ripple,
  },
  data(){
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 500)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return{
        dateFormat:'%n/%Y',
        maxCfgDate:maxDate,
        minCfgDate:minDate,
        setLang:'es',
        init_date:now,
        end_date:now,
        modalShow:false,
        animals:0,
        animals_records:null,
        report:"Mes",
        sick_animals_qty:0,
        sick_animals:0,
        brucelosis:0,
        tuberculosis:0,
        rabia:0,
        mastitis:0,
        renquera:0,
        diarreaChilds:0,
        diarrea:0,
        deaths:0,
        childs_deaths:0,
        animal_charge:0,
        dest_weight:0,
        incomes:0,
        avg_weight:0,
        expenses:0,
        milk:0,
        dayli:0,
        columns: [
        {
          label:  'CODIGO',
          field:  'number',
          type:   'string'
        },  
        {
          label:  'ANIMAL',
          field:  'name',
          type:   'string'
        },
        {
          label:  'SEXO',
          field:  'sex',
          type:   'boolean'
        },
        {
          label:  'PESO',
          field:  'weight',
          type:   'number'
        },
        {
          label:  'EDAD',
          field:  'age',
          type:   'number'
        },

      ],
    }
  },
  computed: {

  },
  methods:{
    async fetchAnimals(config){
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.animals = result.animals.length;
            this.animals_records= result.animals;
            console.log(this.animals);
        })
    },

    async fetchSickAnimals(config){
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sick=1", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.sick_animals_qty = result.animals.length;
            this.sick_animals=result.animals;
            console.log(this.animals);
            this.fetchDeathAnimals(config);
        })
    },
    async fetchDeathAnimals(config){
        let farmId= localStorage.getItem('currentFarm');
        let initDate = this.init_date;
        let endDate= this.end_date;
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        fetch(this.$apiUrl+"list/animal_exits?farm_id="+farmId+"&sick=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animal_exits);
                let deaths= result.animal_exits.filter(item=>{
                    let itemRegDate= new Date(item.date)
                    return itemRegDate>= initDateObj && itemRegDate<=endDateObj && item.reason=='Muerte'
                });
                let deatshQty= deaths.length;
                this.deaths= (deatshQty/this.sick_animals_qty).toFixed(2);
            })
    },

    async fetchHealthRecords(config){
        let initDate = this.init_date;
        let endDate= this.end_date;
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        let farmId= localStorage.getItem('currentFarm');
        this.brucelosis=0;
        this.tuberculosis=0;
        this.diarrea=0;
        this.mastitis=0;
        this.deaths=0;
        this.childs_deaths=0;
        this.rabia=0;
        let arrbrucelosis=[];
        let arrtuberculosis=[];
        let arrdiarrea=[];
        let arrmastitis=[];
        let arrrdeaths=[];
        let arrrchildsdeaths=[];
        let arrrabia=[];
        let arrrrenquera=[];
        let arrrmastitis=[];
        fetch(this.$apiUrl+"list/health_records?farm_id="+farmId+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            
            result.health_records .filter(function(item){
                let itemRegDate= new Date(item.date);
                return itemRegDate>= initDateObj && itemRegDate<=endDateObj;
            }).map(item => {
                console.log(item)
                if(item.type_id==4){
                    if(item.diagnosis==16){
                        arrdiarrea.push(item);
                        this.diarrea=parseInt(arrdiarrea.length);
                        const filteredAnimals = this.animals_records.filter(animal => animal.weight < 250);
                        const totalFiltered = filteredAnimals.length;

                        // Contar cuántos de esos animales están en arrdiarrea
                        const countWithDiarrhea = filteredAnimals.filter(animal => 
                            arrdiarrea.some(diarrheaRecord => diarrheaRecord.animal_id === animal.id)
                        ).length;

                        // Calcular el porcentaje
                        this.diarreaChilds = totalFiltered > 0 ? ((countWithDiarrhea / totalFiltered) * 100).toFixed(2) : 0;

                    }else if(item.diagnosis==65){
                        arrrabia.push(item);
                        this.rabia=parseInt(arrrabia.length);
                    }
                    else if(item.diagnosis==64){
                        arrrrenquera.push(item);
                        this.renquera=parseInt(arrrrenquera.length);
                    }
                    else if(item.diagnosis==17){
                        arrrmastitis.push(item);
                        this.mastitis=parseInt(arrrmastitis.length);
                    }
                }else if(item.type_id==3){
                    if(item.exam_type_id==1){
                        arrbrucelosis.push(item);
                        this.brucelosis=parseInt(arrbrucelosis.length);
                    }else if(item.exam_type_id==2){
                        arrtuberculosis.push(item);
                        this.tuberculosis=parseInt(arrtuberculosis.length);
                    }
                } 
            })
        })
    },
    
    dateFormatter(date, months){
        var month = date.getMonth();
        var year = date.getFullYear();
        var day = date.getDate();
        var lastDay = new Date(year, month, 0);
        if (month === 0) {
            month = 11;
            year = year - 1;
        } else {
            month = month - months;
        }
        if (day > lastDay.getDate()) {
            day = lastDay.getDate();
        }
        var newDate = new Date(year, month, 1);
        return newDate;
    },
    
    fillData(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchHealthRecords(config);
        this.fetchSickAnimals(config);
    },
  },
  watch:{
    'init_date': function(val){
        console.log(val);
        this.fillData();
    },
    'end_date': function(val){
        console.log(val);
        this.fillData();
    },
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    let now = new Date()
    let dateReg= new Date(now.getFullYear(), now.getMonth(), 1);
    this.fetchAnimals(config);
    this.fetchSickAnimals(config);
    this.fetchHealthRecords(config,dateReg)
  },
}
</script>

<style>
.reportTitle {

    font-weight: 600;
    font-size: 24px;

}

.indicaterEco {
    font-weight: 500;
    font-size: 18px;
}
</style>